<template>
  <div class="edit-table">
    <div class="padding_50">
      <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-button @click="productNameClick()" v-if="!disabled"
            >添加物料</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        show-overflow=""
        ref="fineTable"
        :data="subjectList"
        height="100px"
      >
        <vxe-table-column min-width="100" field="code" title="物料编码">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="name" title="物料名称">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="classifyName" title="物料分类">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="kind" title="具体品类">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="spec" title="规格型号">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="unitName" title="单位">
        </vxe-table-column>
        <vxe-table-column
          min-width="100"
          field="num"
          title="数量"
        >
          <template #default="{ row,rowIndex }">
            <el-input-number
              v-model="row.num"
              :precision="0"
              placeholder="数量"
              :disabled="disabled"
              :controls="false"
              @change="changeNumber(row, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          min-width="100"
          field="price"
          title="单价"
        >
          <template #default="{ row,rowIndex }">
            <el-input-number
              v-model="row.price"
              :precision="2"
              placeholder="单价"
              :disabled="disabled"
              :controls="false"
              @change="changeNumber(row, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          min-width="100"
          field="totalPrice"
          title="总价"
        >
          <template #default="{ row }">
            <el-input-number
              v-model="row.totalPrice"
              placeholder="总价"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          title="操作"
          width="100"
          show-overflow
          v-if="!disabled"
          key="操作"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" size="mini" @click="deletRow(row, rowIndex)"
              >删除</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'addForm',
  components: {
    SelectConfig,
  },
  props: {
    value: Array,
    disabled: Boolean,
    materialClassifyList: Array,
    materialUnitList: Array,
  },
  watch: {
    value: {
      handler(val) {
        this.subjectList = val || [];
      },
      deep: true,
    },
  },
  data() {
    return {
      subjectList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.subjectList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log(this.subjectList, 'subjectList');
        this.$refs.fineTable.remove(row);
        this.subjectList.splice(rowIndex, 1);
        this.$emit('input', this.subjectList);
        this.$message({ type: 'success', message: '删除成功!' });
      });
    },
    // 打开点击弹窗产品名称
    productNameClick() {
      const params = {
        data: this.subjectList,
        selectionList: [],
        functionCode: 'material_list',
        idKey: 'code',
        noReset: true,
        paramData: {
          enableStatus: '009',
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      const data = this.getReset(val, [], 'id');
      this.subjectList = this.getReset(this.subjectList.concat(data), [], 'code');
      this.subjectList = this.subjectList.map((item) => ({
        ...item,
        materialId: item.id,
        classifyName: ((this.materialClassifyList || []).find((v) => v.dictCode === item.classify) || {}).dictValue || '',
        unitName: ((this.materialUnitList || []).find((v) => v.dictCode === item.unit) || {}).dictValue || '',
      }));
      this.$emit('input', this.subjectList);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },
    // 计算总价
    changeNumber(row, index) {
      console.log(row, index);
      const totalPrice = this.floatMul(row.num || 0, row.price || 0);
      this.subjectList[index].totalPrice = totalPrice;
      let amount = 0;
      this.subjectList.forEach((i) => {
        amount = this.accAdd(amount, Number(i.totalPrice));
      });
      this.$emit('input', this.subjectList);
      this.$emit('addTotal', amount || 0);
    },
    // 乘
    floatMul(arg1 = 0, arg2 = 0) {
      let m = 0;
      const s1 = arg1.toString();
      const s2 = arg2.toString();
      // eslint-disable-next-line no-empty
      try { m += s1.split('.')[1].length; } catch (e) {}
      // eslint-disable-next-line no-empty
      try { m += s2.split('.')[1].length; } catch (e) {}
      // eslint-disable-next-line no-mixed-operators
      return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / 10 ** m;
    },
    // 两个浮点数求和
    accAdd(num1 = 0, num2 = 0) {
      let r1;
      let r2;
      let m = 0;
      try {
        r1 = num1.toString().split('.')[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = num2.toString().split('.')[1].length;
      } catch (e) {
        r2 = 0;
      }
      // eslint-disable-next-line no-restricted-properties
      m = Math.pow(10, Math.max(r1, r2));
      // return (num1*m+num2*m)/m;
      return Math.round(num1 * m + num2 * m) / m;
    },
  },
};
</script>

<style lang="less" scoped>
.padding_50 {
  padding-left: 20px;
}
.form_title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-left: 0;
  margin-top: 14px;
  margin-bottom: 20px;
}
.edit-table {
  margin-left: 0 !important;
}
.cost-select {
  position: relative;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }
  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
</style>
